var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Ptn, } from "../../utils/api/result-data-type/dataAccess";
import { Typography, Grid, Checkbox, FormControlLabel, debounce } from "@mui/material";
const ResultDataTypeCheckboxList = ({ trialID, onDataTypeCheckboxesChanged, trialResultCategoryName, }) => {
    const [resultDataTypes, setResultDataTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const resultDataTypesCount = resultDataTypes.length;
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const apiResponse = yield Ptn.ResultDataType.getResultDataTypes(trialID);
                if (apiResponse.status === 200 &&
                    apiResponse.data &&
                    apiResponse.data instanceof Array) {
                    setResultDataTypes(apiResponse.data);
                    if (apiResponse.data.length === 0)
                        return;
                }
                else {
                    setError(apiResponse.message);
                }
            }
            catch (err) {
                if (err instanceof Error) {
                    setError(err.message);
                }
            }
            finally {
                setLoading(false);
            }
        });
        //call on quality result category only
        if (trialResultCategoryName === "Quality") {
            const handle = debounce(fetchData, 500);
            handle();
            return () => handle.clear();
        }
        else {
            setLoading(false);
        }
    }, [trialID, trialResultCategoryName]);
    const handleCheckboxChange = (id, checked) => {
        //update model and state
        const updatedResultDataTypes = resultDataTypes.map((dataType) => {
            if (dataType.id === id) {
                return Object.assign(Object.assign({}, dataType), { checked: checked });
            }
            return dataType;
        });
        setResultDataTypes(updatedResultDataTypes);
        const checkedDataTypeIds = updatedResultDataTypes.filter((dataType) => dataType.checked).map((dataType) => dataType.id);
        onDataTypeCheckboxesChanged(checkedDataTypeIds);
    };
    if (loading) {
        return React.createElement("div", null, "Getting quality parameters...");
    }
    if (error) {
        return React.createElement("div", null,
            "Error: ",
            error);
    }
    // no quality then return null
    return resultDataTypesCount === 0 ? null : (React.createElement(Grid, { container: true, sx: {
            marginTop: "0px",
            marginBottom: "0px",
            border: "solid 0px #d3d3d3",
            width: "100%",
            minWidth: "100%",
            alignItems: "left",
            textAlign: "left",
        } },
        React.createElement(Grid, { item: true, xs: 12, sm: 1 },
            React.createElement(Typography, { variant: "body1", sx: {
                    padding: "17px 10px 0px 0px",
                    fontWeight: "bold",
                    color: "#005533",
                } }, "Quality")),
        React.createElement(Grid, { item: true, xs: 12, sm: 11 },
            React.createElement(Grid, { container: true, sx: { border: "solid 0px silver", padding: "7px 0px 0px 0px" } }, resultDataTypes.map((dataType) => (React.createElement(Grid, { item: true, xs: 2, key: dataType.id },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { sx: { color: "#005533" }, checked: dataType.checked, onChange: (e) => handleCheckboxChange(dataType.id, e.target.checked) }), label: React.createElement(Typography, { variant: "body1", sx: {
                            fontWeight: "normal",
                            fontSize: "0.8em",
                            color: "#005533",
                        } }, `${dataType.dataTypeDescription} - (${dataType.dataTypeName})`) })))))))); // end of return
};
export default ResultDataTypeCheckboxList;
